module.exports = __webpack_public_path__ + "img/AdminLOGO.921d8d48.svg";